import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFloppyDisk2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFloppyDisk2"><Path d="M9.5 15C9.5 13.6193 10.6193 12.5 12 12.5C13.3807 12.5 14.5 13.6193 14.5 15C14.5 16.3807 13.3807 17.5 12 17.5C10.6193 17.5 9.5 16.3807 9.5 15Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M17.5607 3H16V9H8V3H3V21H21V6.43934L17.5607 3ZM12 11C9.79086 11 8 12.7909 8 15C8 17.2091 9.79086 19 12 19C14.2091 19 16 17.2091 16 15C16 12.7909 14.2091 11 12 11Z" fill="currentColor"/><Path d="M9.5 3H14.5V7.5H9.5V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFloppyDisk2;
